import React from 'react'

export default function HomeMessage() {
  return (
    <>
    <section className="home-message bodygap">
        <img src="/image/message-banner.webp" className="img-responsive message-desktop" alt="message" loading="lazy"/>
        <img src="/image/message-banner-mobile.webp" className="img-responsive message-mobile" alt="message" loading="lazy"/>

        <div className="homemessage-text wow animate__animated animate__slideInRight" data-wow-duration="1.1s" data-wow-delay="0.2s">
            <div>
                <p>To every bride and every mother visiting, know this-your journey, your hopes, and your quiet expectations guide my hands. My work is simply an extension of your love and your dreams.</p>
                <span>- Sonam Brahme</span>
            </div>
        </div>
    </section> 
    </>
  )
}
